const API_LIST = {
  // 分音塔接口

  // 获取学校列表
  getSchoolList: {
    method: "post",
    url: "/schools"
  },

  // 获取学校月份事件统计
  getMonthEvent: {
    method: "post",
    url: "/eventCount"
  },

  // 获取学校周事件类型统计
  getWeekEvent: {
    method: "post",
    url: "/eventType"
  },

  // 获取学校周响应率统计
  getWeekEventRate: {
    method: "post",
    url: "/eventRate"
  },

  // 获取学校最新事件列表
  getEventNew: {
    method: "post",
    url: "/eventNew"
  },

  // 获取学校未处理事件列表
  getEventUnHandle: {
    method: "post",
    url: "/eventUntreated"
  },

  // 获取学校欺凌事件列表
  getEventBully: {
    method: "post",
    url: "/eventBully"
  }
};

// 对象导出去
export default API_LIST;
